import React from "react";
import LoginPage from "./views/LoginPage";
import { LoginEmailPasswordContextProvider } from "./LoginView";
import LoginContent from "../../constants/contentFile.json";

const Login = () => {
  return (
    <LoginEmailPasswordContextProvider>
      <LoginPage textContents={LoginContent.loginPage} />
    </LoginEmailPasswordContextProvider>
  );
};
export default Login;
